import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function HierarchyIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 14C18.5846 14.0001 19.667 15.0824 19.667 16.417V18.083C19.667 19.4176 18.5846 20.4999 17.25 20.5H13.084C11.7493 20.5 10.667 19.4177 10.667 18.083V16.417C10.667 15.0823 11.7493 14 13.084 14H17.25ZM13.084 15.5C12.5777 15.5 12.167 15.9107 12.167 16.417V18.083C12.167 18.5893 12.5777 19 13.084 19H17.25C17.7561 18.9999 18.167 18.5892 18.167 18.083V16.417C18.167 15.9108 17.7561 15.5001 17.25 15.5H13.084Z"
        fill="currentColor"
      />
      <path
        d="M4.75 4C5.16421 4 5.5 4.33579 5.5 4.75V7.33398H8.91699L8.99316 7.33789C9.37141 7.37624 9.66699 7.69562 9.66699 8.08398C9.66667 8.4721 9.37125 8.79179 8.99316 8.83008L8.91699 8.83398H5.5V15.583L5.50488 15.6768C5.5517 16.1391 5.94228 16.5 6.41699 16.5H8.91699L8.99316 16.5039C9.37144 16.5422 9.66699 16.8616 9.66699 17.25C9.66699 17.6384 9.37144 17.9578 8.99316 17.9961L8.91699 18H6.41699C5.16561 18 4.13631 17.0489 4.0127 15.8301L4 15.583V4.75C4 4.33579 4.33579 4 4.75 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 4.83301C18.5845 4.83314 19.6668 5.91553 19.667 7.25V8.91602C19.667 10.2506 18.5846 11.3329 17.25 11.333H13.084C11.7493 11.333 10.667 10.2507 10.667 8.91602V7.25C10.6672 5.91545 11.7494 4.83301 13.084 4.83301H17.25ZM13.084 6.33301C12.5778 6.33301 12.1672 6.74388 12.167 7.25V8.91602C12.167 9.42228 12.5777 9.83301 13.084 9.83301H17.25C17.7561 9.83288 18.167 9.42219 18.167 8.91602V7.25C18.1668 6.74396 17.756 6.33314 17.25 6.33301H13.084Z"
        fill="currentColor"
      />
    </svg>
  );
};
